import { SectionTitle, SectionTitleSize, SectionTitleStyle } from '../../components/SectionTitle/SectionTitle'

import styles from './RouteSelection.module.css'

import { ReactComponent as Benchmark } from '../../images/icons/benchmark.svg'

type RouteSelectionProps = {
  // onContractor is retained so the contractor route can be restored later (#56)
  onContractor: () => void
  onBenchmark: () => void
}

function RouteSelection(props: RouteSelectionProps) {
  return (
    <div className={styles.container}>
      <SectionTitle subtitle='WELCOME TO OUR WIZARD' title={'PLEASE SELECT A ROUTE'} size={SectionTitleSize.Small} style={SectionTitleStyle.LightBlue} />
      <div className={styles.grid}>
        {/* Contractor route card removed for now per Steve (#56). The
            contractor flow code remains in MultiForm so it can be restored by
            reinstating this card. */}
        <div
          className={`${styles.card} ${styles.benchmark}`}
          onClick={props.onBenchmark}
        >
          <div className={styles.iconWrapper}>
            <Benchmark/>
          </div>
          <div className={styles.cardContent}>
            <span className={styles.cardTitle}>Benchmark</span>
            <span className={styles.cardDescription}>
              Benchmark all contractors for a service to find the best value option
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export { RouteSelection }
